import { render, staticRenderFns } from "./SupplierPerformanceReportRightBarChart.vue?vue&type=template&id=0841d8bc&scoped=true&"
import script from "./SupplierPerformanceReportRightBarChart.vue?vue&type=script&lang=js&"
export * from "./SupplierPerformanceReportRightBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPerformanceReportRightBarChart.vue?vue&type=style&index=0&id=0841d8bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841d8bc",
  null
  
)

export default component.exports